import React from "react";
import { PlaneIcon, PinIcon, CalendarIcon, HotelIcon, SignpostIcon, PeopleIcon } from "../../../../SubModules/Olympic.DesignFramework/react/icons.jsx";

// The search field icons: the designer's icons (Olympic.DesignFramework assets/icons, 30 Sep 2026), in currentColor,
// sized by PopoverInput. Rooms & Guests uses the people icon (the category comp, 7 Oct 2026; the homepage comp had the hotel).
const iconClass = "size-5 shrink-0";

export const planeIcon = <PlaneIcon className={iconClass} />;
export const pinIcon = <PinIcon className={iconClass} />;
export const calendarIcon = <CalendarIcon className={iconClass} />;
export const hotelIcon = <HotelIcon className={iconClass} />;
export const signpostIcon = <SignpostIcon className={iconClass} />;
// wider than it is tall (1.81:1): the field icon height, its own width (the comp's 35 x 19)
export const peopleIcon = <PeopleIcon className="h-5 w-auto shrink-0" />;
